import { ReactComponent as StatusSpinnerSVG } from '../assets/images/status-spinner.svg';

const StatusSpinner = () => {
  return <StatusSpinnerSVG className="text-old-blue animate-spin" />;
}

export default StatusSpinner;
